<template>
  <a-modal
    :title="isEdit? $t('page_console_notification_rule_edit') : $t('page_console_notification_rule_add')"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :width="600"
    @cancel="handleCancel"
  >
  <a-form-model :model="form" ref="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
    <a-form-model-item :label="$t('page_console_notification_rule_rule_name')" prop="ruleName">
      <a-input v-model="form.ruleName" :placeholder="$t('please_select') + $t('page_console_notification_rule_rule_name')"/>
    </a-form-model-item>
    <a-form-model-item :label="$t('page_console_notification_rule_subordinate_to_business')" prop="dictKey">
      <a-select
      show-search
      :filter-option="filterOption"
      :placeholder="$t('please_select') + $t('page_console_notification_rule_subordinate_to_business')"
      v-model="form.dictKey">
        <a-select-option :value="item.dictKey" v-for="(item,index) in businessList" :key="index">
          {{item.dictName}}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item v-if="form.dictKey!=='work-record-status-change'" :label="$t('page_console_notification_rule_device_group')" prop="groupIds">
      <div class="deviceGroup">
        <a-tree
            checkable
            :auto-expand-parent="true"
            :selectable="false"
            :default-expanded-keys="form.groupIds"
            :checkedKeys="checkedKeys"
            :tree-data="treeData"
            :replace-fields="replaceFields"
            @check="onChoseDevChange"
          />
      </div>
    </a-form-model-item>
  </a-form-model>

  </a-modal>

</template>

<script>
 import { DataTreeNode } from '@/utils/array'
import { WorkStationGroupServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies"
import { NotificationRuleBusinessServiceProxy } from "@/service-proxies/app-v2/notify.service-proxies"
const notificationRuleBusinessServiceProxy = new NotificationRuleBusinessServiceProxy();
const workStationGroupServiceProxy = new WorkStationGroupServiceProxy();
export default {
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    isEdit:{
      type:Boolean,
      default:false
    },
    id:{

    }
  },
  watch:{
    visible:async function(newVal){
      if(newVal){
        await this.getWorkStationGroup();
        if(this.isEdit){
          this.getDetail();
        }
      }
    }
  },
  methods:{
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 获取详情
    getDetail () {
      if (!this.id) return
      notificationRuleBusinessServiceProxy.getNotificationRuleBusiness(this.id).then(res => {
        let devIds = [], workStationIds = []
        if (res.groupId) {
          devIds = res.groupId.split(',')
        }
        if (res.workstationId) {
          workStationIds = res.workstationId.split(',')
        }
        this.form = {
          id: res.id,
          ruleName: res.ruleName,
          dictKey: res.dictKey,
          groupIds: devIds
        }
        this.checkedKeys = [...devIds, ...workStationIds]
      })
    },
    // 获取工位组
    async getWorkStationGroup(){
      this.treeData = [];
      await workStationGroupServiceProxy.workStationGroupList().then(res => {
         this.workStationGroupList = res;
        //  let groupList = res.filter(item => item.isGroup);
        let groupList = res.map(item => {
          // item.disableCheckbox = !item.isGroup;
          return item;
        })
         this.treeData = DataTreeNode.arrayToTree(groupList);
         this.$nextTick(() => {
           this.defaultExpandedKeys = this.treeData.map(item => item.id);
         })

      })
    },
    onLoadData(treeNode) {
      return new Promise(resolve => {
        // console.log(treeNode)
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        // console.log(treeNode.dataRef.id);
        resolve();
        // setTimeout(() => {
        //   treeNode.dataRef.children = [
        //     { name: 'Child Node', key: `${treeNode.eventKey}-0` },
        //     { name: 'Child Node', key: `${treeNode.eventKey}-1` },
        //   ];
        //   this.treeData = [...this.treeData];
        //   resolve();
        // }, 1000);
      });
    },
    onChoseDevChange(data){
      this.$set(this.form,'groupIds',data);
      this.checkedKeys = data
      this.$refs.form.validateField('groupIds');
    },
    handleOk(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.handleSubmit();
        } else {

        }
      });
    },
    handleSubmit(){
      this.confirmLoading = true;
      let data = {
        ruleName:this.form.ruleName,
        dictKey:this.form.dictKey,
        dictName: "",
      }
      let findDict = this.businessList.find(item => item.dictKey == this.form.dictKey);
      if(findDict){
        data.dictName = findDict.dictName
      }
      let workstationId = [], groupIds = [];
      // this.form.groupIds
      this.checkedKeys.forEach(id => {
        this.workStationGroupList.forEach(item => {
          if (item.id === id) {
            // 选中的工位
            if (item.isWorkStation && !workstationId.includes(item.id)) {
              workstationId.push(item.id)
              // groupIds.push(item.parentId)
            }
            // 选中的工位组
            if (item.isGroup && !groupIds.includes(item.id)) {
              groupIds.push(item.id)
            }
          }
        })
      })
      data.groupId = Array.from(new Set(groupIds)).join();
      data.workstationId = workstationId.join();
      if(this.isEdit){
        data.id = this.id
      }
      // 工作记录状态变化 不传工位信息
      if(data.dictKey === 'work-record-status-change') {
        data.groupId = ''
        data.workstationId = ''
      }

      notificationRuleBusinessServiceProxy.submit(data).then(res => {
        this.confirmLoading = false;
        if(this.isEdit){
          this.$message.success(this.$t('page_console_notification_rule_edit_success'))
        }else{
          this.$message.success(this.$t('page_console_notification_rule_add_success'))
        }
        this.$emit('success');
        this.$refs.form.resetFields()
      }).catch(() => {
        this.confirmLoading = false;
      })
    },
    handleCancel(){
      this.$emit('cancel', false)
      this.$refs.form.resetFields()
    }
  },
  data(){
    return {
      confirmLoading:false,
      form:{
        groupIds:[]
      },
      checkedKeys: [],
      treeData:[],
      defaultExpandedKeys:[],
      replaceFields: {
        key:'id'
      },
      businessList:[{
        dictKey:'device-state-notify',
        dictName:'设备状态通知'
      },{
        dictKey:'over-flow-warning',
        dictName:'工位产量超差预警'
      },{
        dictKey:'work-record-status-change',
        dictName:'工作记录状态变化'
      }],
      rules: {
        ruleName: [
          { required: true, message: this.$t('common_please_input'), trigger: 'blur' },
        ],
        dictKey:[{ required: true, message: this.$t('please_select'), trigger: 'change' }],
        groupIds: [
          {
            type: 'array',
            required: true,
            message: this.$t('please_select'),
            trigger: 'change',
          },
        ]
      },
    }
  }
}
</script>

<style lang="less" scoped>
.deviceGroup{
  max-height: 300px;
  overflow-y: auto;
  border:1px solid #d9d9d9;
  padding: 4px 11px;
  min-height: 150px;
}
/deep/ .ant-tree-checkbox-disabled{
  visibility:hidden;
}

</style>
